import { Text } from '@jfs/ui-new'
import { monthShotForm } from '../../util/util'

export const DisplayDateFormat = ({ date }: any) => {
  const formatedDate = () => {
    try {
      const today = new Date()
      const currentDate = today.getDate() < 10 ? `0${today.getDate()}` : `${today.getDate()}`
      const currentMonth = today.getMonth() < 8 ? `0${today.getMonth() + 1}` : `${today.getMonth() + 1}`
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1))
      const yesterdayDate = yesterday.getDate() < 10 ? `0${yesterday.getDate()}` : `${yesterday.getDate()}`
      const dateAndTimeArr = date?.split(',')
      const timeString = dateAndTimeArr[1]
      const dateArr = dateAndTimeArr[0]?.split('-')
      const dateFormated = dateArr[0]
      const month = `${dateArr[1]}`
      const removedZero: any = month.indexOf('0') === 0 ? month.slice(1) : month
      const monthToDisplay = monthShotForm[parseInt(removedZero, 10) - 1]
      if (dateFormated === currentDate && currentMonth === month) {
        return timeString?.toLocaleLowerCase()
      } else if (dateFormated === yesterdayDate && currentMonth === month) {
        return "Y'day"
      } else {
        return `${dateFormated} ${monthToDisplay}`
      }
    } catch (error) {
      return date
    }
  }

  return (
    <>
      <Text fontFamily={'JioType-Medium'} fontSize={10} letterSpacing={-0.06} color="WHITE">
        {formatedDate()}
      </Text>
    </>
  )
}
